module.exports = __webpack_public_path__ + "static/media/option-2.19cf23af.ogg";